module.exports = __webpack_public_path__ + "static/img/technology-1.150c7b2e.png";